import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, InventarioSetorStorage } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InventarioStorageService extends BaseResourceService<InventarioSetorStorage> {

  constructor(
    protected injector: Injector
  ) {
    super(`inventario-setor-storages`, injector);
  }

  public upload(arquivos: any[], orgao: number, manutencao: number, descricao?: string): Observable<InventarioSetorStorage[]> {
    const formData = new FormData();
    for (let arquivo of arquivos) {
      formData.append('files', arquivo);
    }
    if (descricao) {
      formData.append('descricao', descricao);
    }

    const headers = this.httpOptions();
    headers.headers = headers.headers.delete('Content-Type');

    return this.http.post<InventarioSetorStorage[]>(`${this.login.cidade.id}/${this.api}/upload/${orgao}/${manutencao}`,
      formData, headers)
      .pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

}
